export default {
  items: [
        {
          name: 'Progress Belajar',
          //url: '/full/base/dropdowns',
          icon: 'icon-puzzle',
          children: [
            {
                name: 'Python Introduction',
                materiKey: 'python',
                icon: 'icon-puzzle'
            },
            {
                name: 'HTML',
                materiKey: 'html',
                icon: 'icon-book-open'
            },
            {
                name: 'C++',
                materiKey: 'cpp',
                icon: 'icon-graduation'
            }
            ]
        },

    ]
}